import { z } from 'zod';

export const PushyPaywallInstance = z.object({
  layout: z.string(),
  backgroundImage: z.string(),
  foregroundImage: z.string(),
  title: z.string(),
  titleHighLightedPart: z.string(),
  subtitle: z.string(),
});
export type PushyPaywallInstance = z.infer<typeof PushyPaywallInstance>;

export const PushyPaywallDefinition = z.object({
  paddingTimeMinutes: z.number(),
  paywalls: z.array(PushyPaywallInstance),
  cta: z.object({
    buttonText: z.string(),
    offerTitle: z.string(),
    offerSubtitle: z.string(),
    footerText: z.string(),
  }),
});
export type PushyPaywallDefinition = z.infer<typeof PushyPaywallDefinition>;
